import { CHARACTER_COUNT } from '../../../../../shared/constants/global';
import { type FieldSchema, type ValidatorContext } from '../types';

import createBaseStringValidator from './baseStringValidator';

const createTextValidator = (context: ValidatorContext): FieldSchema =>
  createBaseStringValidator(context, {
    defaultMaxLength: CHARACTER_COUNT.TEXT_MAX,
    useMinValidationForRequired: false,
    includeMinMaxValueValidation: true,
    includeExpressionValidation: true,
  });

export default createTextValidator;
